/** Psychological alignment tags for link-imported pieces (Chic set). */
export const CHIC_WARDROBE_MOODS = [
  "Confidence",
  "Calm",
  "Productivity",
  "Focus",
  "Joy",
];
